import React from 'react'

import { Flex, InfoBadge } from '@driftt/dds'

import { OpportunityAttributionProps } from './OpportunityAttribution.types'

export const OpportunityAttribution = ({
  isInfluenced = false,
  isSourced = false,
}: OpportunityAttributionProps) => {
  return (
    <Flex>
      {isInfluenced && <InfoBadge variant="primary">{'Influenced'}</InfoBadge>}
      {isSourced && <InfoBadge variant="secondary">{'Sourced'}</InfoBadge>}
    </Flex>
  )
}
